import React, { useState, useMemo, useEffect } from 'react';
import { Button, Card, Col, Container, Form, Modal, Offcanvas, Row, ListGroup, InputGroup } from 'react-bootstrap';
import Breadcrumb from '../../Common/BreadCrumb';
import TableContainer from "../../Common/TableContainer";
import CreateSpecification from './CreateSpecification';
import { useDeletesizeMutation, useSizelistMutation } from '../../Redux/SizeSlice';
import { getQueryString } from "../../lib/Validationtext";
import moment from "moment";
import DeleteModal from '../../Common/modals/DeleteModal';
import { toast } from 'react-toastify'
import CreateSpecificationType from './CreateSpecificationType';
import { useGetSpecificationsMutation, useGetSpecificationsQuery, useSpecificationDeleteMutation } from '../../Redux/specification/specificationApi';
// import { useCreateSpecificationMutation } from '../../Redux/specification/specificationApi';


const Specificationlist = () => {
    document.title = "Coupons | Toner eCommerce + Admin React Template";
    // const [createSpectificationTypeFn] = useCreateSpecificationMutation();


    // const [sizeDeleteFunc, { data: deleteData, error: deleteErr, isLoading: deleteLoading, isSuccess: DeleteSuccess }] = useDeletesizeMutation();
    const [specificationDeleteFunc, { data: deleteData, error: deleteErr, isLoading: deleteLoading, isSuccess: DeleteSuccess }] = useSpecificationDeleteMutation()

    const [SpecificationData, setSpecificationData] = useState(false);
    console.log(SpecificationData, "SpecificationData");
    const [showCoupons, setShowCoupons] = useState(false);
    const [open, setOpen] = useState(false);
    const [openType, setOpenType] = useState(false);
    const [showModal, setShowModal] = useState(false);

    const [page, setPage] = useState(0);
    const [limit, setlimit] = useState(10);

    const { data: listData, isLoading: listLoading } = useGetSpecificationsQuery(getQueryString({ page: page + 1, limit: limit }));


    useEffect(() => {
        if (DeleteSuccess) {
            setShowModal(false)
            const message = deleteData?.message || "Delete successfully";
            toast.success(message);
            setSpecificationData({})
            // SizelistFunc(getQueryString({ page: page + 1, limit: limit }))

        }
        // if (deleteErr) {
        //     if ('data' in deleteErr) {
        //         const errorData = error;
        //         toast.error(errorData.data.message);

        //     }
        // }
    }, [deleteData, DeleteSuccess, deleteErr]);
    // useEffect(() => {
    //     // SizelistFunc(getQueryString({ page: page + 1, limit: limit }))
    // }, [page, limit, DeleteSuccess, open])

    const columns = useMemo(
        () => [
            {

                Header: "Label",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => {
                    console.log(cellProps, "cellProps");
                    return (
                        <h5 className="mb-0 fs-16">{cellProps?.specificationType?.name}</h5>
                    )
                },
            },
            {

                Header: "Value",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => {
                    return (
                        <>
                            {cellProps?.value?.map((val, index) => (
                                <span style={{ backgroundColor: "#007bff" }} className="badge  text-white text-uppercase" key={index}> {val?.value}</span>
                            ))}
                        </>

                    )
                },
            },
            {
                Header: "Status",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => {
                    switch (cellProps.status) {
                        case true:
                            return (<span className="badge bg-success-subtle text-success text-uppercase"> Active</span>)
                        case false:
                            return (<span className="badge bg-danger-subtle text-danger text-uppercase"> Inactive</span>)
                        default:
                            return (<span className="badge bg-success-subtle text-success text-uppercase"> Active</span>)
                    }
                },
            },
            {
                Header: "Create Date",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => cellProps.createdAt ? moment(cellProps.createdAt).format('DD-MM-YYYY') : '-',
            },

            {
                Header: "Edit Date",
                accessor: "updatedAt",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => cellProps.updatedAt ? moment(cellProps.updatedAt).format('DD-MM-YYYY') : '-',
            },

            {
                Header: "Action",
                disableFilters: true,
                filterable: true,
                accessor: (cellProps) => {
                    return (
                        <ul className="hstack gap-2 list-unstyled mb-0">
                            <li>
                                <Button className="badge bg-primary-subtle text-primary edit-item-btn" data-bs-toggle="modal"
                                    onClick={() => {
                                        console.log('cellProps.id', cellProps.id)
                                        setOpen(!open)
                                        setSpecificationData(cellProps)
                                    }}
                                >Edit</Button>
                            </li>
                            <li>
                                <Button data-bs-toggle="modal" className="badge bg-danger-subtle text-danger remove-item-btn" onClick={() => {
                                    setSpecificationData(cellProps)
                                    setShowModal(!showModal);
                                }}>Delete</Button>
                            </li>
                        </ul>
                    )
                },
            },




        ], [showCoupons]
    );
    return (
        <React.Fragment>
            <div className="page-content">
                <Container fluid={true}>
                    <Breadcrumb title="Specification" pageTitle="More" />
                    <div id="couponsList">
                        <Row>
                            <Col xxl={12}>
                                <Card>
                                    <Card.Body>
                                        <Row className="align-items-center">
                                            <Col xxl={3} md={5}>
                                                <div className="search-box mb-3 mb-md-0">
                                                    <input type="text" className="form-control search" id="searchProductList" placeholder="Search by specification name..." />
                                                    <i className="ri-search-line search-icon"></i>
                                                </div>
                                            </Col>
                                            <Col className="col-md-auto ms-auto">
                                                <Button variant='success' onClick={() => {
                                                    setSpecificationData({})
                                                    setOpenType(true)
                                                }} className="add-btn me-2"><i className="bi bi-plus-circle me-1 align-middle "></i>Add Specification Type</Button>
                                                <Button variant='success' onClick={() => {
                                                    setOpen(!open)
                                                    setSpecificationData({})
                                                }} className="add-btn"><i className="bi bi-plus-circle me-1 align-middle"></i>Add Specification</Button>
                                            </Col>
                                        </Row>
                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12}>
                                <Card>
                                    <Card.Body className='p-0'>
                                        <TableContainer
                                            columns={(columns || [])}
                                            data={(listData?.response || [])}
                                            iscustomPageSize={false}
                                            isBordered={false}
                                            customPageSize={5}
                                            className="custom-header-css table align-middle table-nowrap"
                                            tableClass="table-centered align-middle table-nowrap mb-0"
                                            theadClass="text-muted table-light"
                                            SearchPlaceholder='Search Products...'
                                        />
                                        <div className="noresult" style={{ display: "none" }}>
                                            <div className="text-center">
                                                <h5 className="mt-2">Sorry! No Result Found</h5>
                                                <p className="text-muted mb-0">We've searched more than 150+ Orders We did not find any orders for you search.</p>
                                            </div>
                                        </div>

                                    </Card.Body>
                                </Card>
                            </Col>
                        </Row>
                    </div>

                    {open &&
                        <CreateSpecification open={open} setOpen={setOpen} SpecificationData={SpecificationData} />}
                    {showModal && <DeleteModal showModal={showModal} setShowModal={setShowModal} data={SpecificationData} handleSubmit={() => specificationDeleteFunc({ id: SpecificationData?.id })} />}
                    {openType &&
                        <CreateSpecificationType open={openType} setOpen={setOpenType} SpecificationData={SpecificationData} />}
                    {showModal && <DeleteModal showModal={showModal} setShowModal={setShowModal} data={SpecificationData} handleSubmit={() => {
                        specificationDeleteFunc({ id: [SpecificationData?.id] })
                        console.log([SpecificationData?.id], "SpecificationData?.id ");
                    }} />}

                </Container>
            </div>

        </React.Fragment >
    );
};

export default Specificationlist;
